import { memo, useMemo } from 'react';
import classNames from 'classnames';

import { Button } from '../../button/button.component';
import { ImageEmbedded } from '../../image/image-embedded';
import { Text } from '../../text/text.component';
import { TitleV2 } from '../../titlev2/titlev2.component';

import { NavDropdownFooterIsEmptyFn, NavDropdownFooterProps } from './nav-dropdown-footer.config';

const NavDropdownFooter = memo(
  ({
    additionalClasses,
    title,
    description,
    linkItems,
    icon,
    propertiesId,
    propertiesLabel,
    propertiesRole,
    ...props
  }: NavDropdownFooterProps) => {
    const renderedIcon = useMemo(
      () => icon && <ImageEmbedded {...icon} baseCssClass="snowflake-mega-nav-dropdown-footer-icon" />,
      [icon]
    );

    const renderedLinkItems = useMemo(
      () =>
        linkItems?.map((linkItem) => (
          <div
            key={linkItem.linkTitle}
            className="snowflake-button-link snowflake-button-blue snowflake-button-compact"
          >
            <Button isLink buttonLink={{ url: linkItem.linkPath }} text={linkItem.linkTitle} />
          </div>
        )),
      [linkItems]
    );

    return !NavDropdownFooterIsEmptyFn({ title, description, icon, linkItems, ...props }) ? (
      <div
        id={propertiesId}
        aria-label={propertiesLabel}
        role={propertiesRole}
        className={classNames('snowflake-mega-nav-dropdown-footer', additionalClasses)}
        data-testid="snowflake-mega-nav-dropdown-footer"
      >
        <div className="snowflake-mega-nav-dropdown-footer-wrapper">
          {renderedIcon}
          <div className="snowflake-mega-nav-dropdown-footer-content">
            <TitleV2 tabIndex={0} {...title} variantClassName="body-1" type="span" />
            <Text tabIndex={0} {...description} />
            <div className="snowflake-mega-nav-dropdown-footer-links">{renderedLinkItems}</div>
          </div>
        </div>
      </div>
    ) : null;
  }
);

NavDropdownFooter.displayName = 'NavDropdownFooter';

export default NavDropdownFooter;
